import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeviewAreaSystemComponent } from './treeview-area-system.component';
import { DxSortableModule } from 'devextreme-angular/ui/sortable';
import { DxContextMenuModule, DxDropDownBoxModule,DxButtonModule, DxCheckBoxModule, DxDropDownButtonModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxSwitchModule, DxTextAreaModule, DxTextBoxModule, DxTreeViewModule, DxTagBoxModule, DxDataGridModule, DxFileUploaderModule, DxHtmlEditorModule, DxDiagramModule, DxColorBoxModule, DxToolbarModule, DxRadioGroupModule, DxListModule } from 'devextreme-angular';
import { MdbGlobalModule } from '../mdb-global.module';
import { SystemControllerModule } from 'src/app/pages/estimation/system-controller/system-controller.module';
import { EditSystemMultipleModule } from '../EditSystemMultiple/EditSystemMultiple.module';
import { AIestimateModule } from 'src/app/pages/estimation/ai-estimate/ai-estimate.module';
import { ImportLibraryDinamicModule } from 'src/app/pages/estimation/import-from-library/import-from-library.module';
import { PayCreditModule } from '../pay-credit/pay-credit.module';
import { NewPartsModule } from 'src/app/pages/inventory/parts/new-part/new-part.module';



@NgModule({
  declarations: [TreeviewAreaSystemComponent,
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTreeViewModule,
    DxSortableModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxTextAreaModule,
    DxSelectBoxModule,
    DxSwitchModule,
    DxDropDownBoxModule,
    SystemControllerModule,
    DxTagBoxModule,
    DxDataGridModule,
    EditSystemMultipleModule,
    AIestimateModule,
    ImportLibraryDinamicModule,
    DxFileUploaderModule,
    DxHtmlEditorModule,
    PayCreditModule,
    DxDiagramModule,
    DxColorBoxModule,
    DxToolbarModule,
    DxRadioGroupModule,
    DxContextMenuModule,
    DxListModule,
    NewPartsModule
  ],
  exports: [TreeviewAreaSystemComponent,
  ]
})
export class TreeviewAreaSystemModule { }
